<template>
    <job-sheets-entries-store
        ref="job_sheets_entries_store"
        :params="{
            job_sheet: $route.params.job_sheet
        }"
        v-slot="{
            sid,
            is_loading: is_saving,
            error,
            store
        }"
        @success="onSuccess"
    >
        <div class="mb-6">
            <div class="bg-white rounded shadow">
                <header class="flex items-center px-4 py-3 border-b sm:px-6 md:py-4">
                    <h1 class="text-lg font-normal">
                        Leave a comment
                    </h1>
                </header>

                <base-form @submit="store(form)">
                    <div class="px-4 pt-6 border-b sm:px-6">
                        <form-item
                            :sid="sid"
                            :is-required="true"
                            name="text"
                        >
                            <template slot="label">Comment</template>

                            <div class="relative">
                                <input-textarea
                                    v-model="form.text"
                                    :sid="sid"
                                    :disabled="is_saving"
                                    name="text"
                                    class="h-32"
                                />
                            </div>
                        </form-item>

                        <form-item
                            :sid="sid"
                            name="uploads"
                        >
                            <template slot="label">Files</template>

                            <input-uploads
                                v-model="form.uploads"
                                name="uploads"
                                ref="uploads"
                                :sid="sid"
                                :max-files="20"
                                :disabled="is_saving"
                            />
                        </form-item>
                    </div>

                    <div class="px-4 py-3 text-right rounded-b bg-grey-bg sm:px-6">
                        <base-button
                            :is-loading="is_saving"
                            class="w-full btn-blue md:w-auto"
                        >
                            Submit Comment
                        </base-button>
                    </div>

                    <error-modal
                        v-if="error && $error.is(error, { exclude: [422] })"
                        :error="error"
                    />

                    <modal-success :is-open="show_created_modal">
                        <template slot="heading">Comment created!</template>

                        <p>
                            ...
                        </p>

                        <div
                            slot="footer"
                            class="flex flex-col md:flex-row-reverse"
                        >
                            <router-link
                                :to="{
                                    name: $router.fix('dashboard.*.job-sheets.show'),
                                    params: {
                                        job_sheet: $route.params.job_sheet
                                    }
                                }"
                                class="text-center btn btn-green"
                            >
                                Go to Job Sheet
                            </router-link>
                        </div>
                    </modal-success>
                </base-form>
            </div>
        </div>
    </job-sheets-entries-store>
</template>

<script>
    import JobSheetsEntriesStore from '../../../../../components/job-sheets-entries-store'

    export default {
        components: {
            JobSheetsEntriesStore
        },
        data () {
            return {
                show_created_modal: false,
                form: {
                    text: '',
                    uploads: []
                }
            }
        },
        methods: {
            onSuccess () {
                setTimeout(() => {
                    this.show_created_modal = true
                }, 0)
            }
        }
    }
</script>
